import { render, staticRenderFns } from "./ourService.vue?vue&type=template&id=42fe2376&scoped=true"
import script from "./ourService.vue?vue&type=script&lang=js"
export * from "./ourService.vue?vue&type=script&lang=js"
import style0 from "./ourService.vue?vue&type=style&index=0&id=42fe2376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe2376",
  null
  
)

export default component.exports